<template>
  <div
    v-if="item.exists()"
  >
    <div
      class="elevation-2 white"
    >
      <div
        class="mx-auto standard-page-width"
      >
        <v-row
          align="center"
          class="flex-nowrap"
        >
          <v-col
            class="overflow-hidden"
          >
            <ServerPreviewCard
              flat
              :game="item.data.game"
              :item="item"
              tile
            />
          </v-col>
          <v-col
            class="flex-grow-0"
          >
            <ServerLikeButton
              :server="item"
            />
          </v-col>
        </v-row>
        <v-tabs>
          <v-tab
            v-for="(tab, index) in tabs"
            :key="index"
          >
            {{ tab }}
          </v-tab>
        </v-tabs>
      </div>
    </div>
    <v-container
      class="px-0 py-4  standard-page-width"
      fluid
    >
      <v-card>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td
                  class="text-capitalize"
                >
                  {{ $t('language') }}
                </td>
                <td>
                  <v-tooltip
                    open-delay="100"
                    top
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.data.language | localeNativeName }}
                      </span>
                    </template>
                    <span>
                      {{ item.data.language.toUpperCase() }}
                    </span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <td
                  class="text-capitalize"
                >
                  {{ $t('last_updated') }}
                </td>
                <td>
                  <DateTime
                    relative
                    :value="item.data.updated_at"
                  />
                </td>
              </tr>
              <tr>
                <td
                  class="text-capitalize"
                >
                  {{ $t('last_queried') }}
                </td>
                <td>
                  <DateTime
                    relative
                    :value="item.data.queried_at"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { Server } from '@serversgg/sdk-js'

import DateTime from '@/components/DateTime'
import ServerLikeButton from '@/components/ServerLikeButton'
import ServerPreviewCard from '@/components/ServerPreviewCard'

export default {
  name: 'ServerShowView',

  components: {
    DateTime,
    ServerLikeButton,
    ServerPreviewCard,
  },

  data () {
    return {
      item: new Server(),
    }
  },

  computed: {
    tabs () {
      return [
        this.$t('overview'),
      ]
    },
  },

  metaInfo () {
    return {
      title: this.item.exists()
        ? this.item.data.name
        : `${this.$t('loading')}..`,
    }
  },

  async beforeRouteEnter (to, from, next) {
    const item = await Server
      .request()
      .setInclude('game')
      .find(to.params.serverId)

    // eslint-disable-next-line no-return-assign
    next((vm) => vm.item = item)
  },

  async beforeRouteUpdate (to, from, next) {
    Object.assign(this.$data, this.$options.data.call(this))

    this.item = await Server
      .request()
      .setInclude('game')
      .find(to.params.serverId)

    next()
  },
}
</script>
